import React from 'react';
import { DashboardNavigationLink, LeftNavigationBar } from 'common/Navigation';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import { useCurrentPayerId } from 'common/contexts/CurrentProviderContext';
import { useFeatureFlag } from 'common/hooks';
import { useServiceAuthorizationStatusCount } from '../hooks/useServiceAuthorizationStatusCount';

export const StatusSelectBar = () => {
  const payerId = useCurrentPayerId();
  const openCount = useServiceAuthorizationStatusCount(AUTHORIZATION_STATUSES.open, payerId);
  const updateEditAuthorizationsFeatureEnabled = useFeatureFlag('pays-5650-update-edit-authorizations');
  return (
    <LeftNavigationBar className="space-y-1 -mb-20">
      <DashboardNavigationLink
        className="text-base"
        label="Open"
        count={openCount}
        to="/authorizations/open"
      />
      <DashboardNavigationLink
        className="text-base"
        label="Accepted"
        to="/authorizations/accepted"
      />
      {updateEditAuthorizationsFeatureEnabled && (
        <DashboardNavigationLink
          className="text-base"
          label="Voided"
          to="/authorizations/voided"
        />
      )}
      <DashboardNavigationLink
        className="text-base"
        label="Rejected"
        to="/authorizations/rejected"
      />
      <DashboardNavigationLink
        className="text-base"
        label="All Requests"
        to="/authorizations/all"
      />
    </LeftNavigationBar>
  );
};
